import React from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
    margin-left: ${props => props.marginLeft || 'auto'};
    margin-right: ${props => props.marginRight || 'auto'};
    margin-top: ${props => props.marginTop || 0};
    margin-bottom: ${props => props.marginBottomWrapper || '40px'};
    max-width: ${props => props.maxWidth || "100%"};
    color: ${props => props.color};

    em {
        color: #FFA500;
        font-style: normal; 
        font-weight: 600 ;
    }
    ${props => props.theme.mediaQueries.medium}{
        width: ${props => props.widthMediaQueriesMedium};
        max-width: ${props => props.maxWidthMediaQueriesMedium};
        margin-left: 0;
        margin-right: 0;
        margin-bottom: ${props => props.marginBottomWrapperMediaQueriesMedium || '40px'};
    }
`;

const H1 = styled.h1`
    font-size: ${props => props.fontSizeH1 || '1.83rem'};
    font-weight: ${props => props.fontWeightH1};
    line-height: ${props => props.lineHeightH1 || '30px'};
    margin-bottom: ${props => props.marginBottomH1 || '12px'};

    ${props => props.theme.mediaQueries.medium}{
        font-size:  ${props => props.fontSizeH1MediaQueriesMedium || '1.3rem'};
        line-height: ${props => props.lineHeightH1MediaQueriesMedium || '40px'};
        margin-bottom: ${props => props.marginBottomH1MediaQueriesMedium};
    }
`

const P = styled.p`
    font-size: ${props => props.fontSizeP};
    line-height: ${props => props.lineHeightP || '24px'};
    margin-bottom: ${props => props.marginBottomP};

    ${props => props.theme.mediaQueries.medium}{
        font-size: ${props => props.fontSizePMediaQueriesMedium || '0.8rem'};
        line-height: ${props => props.lineHeightPMediaQueriesMedium};
    }
`

const HeaderAndParagraph = ({
    headerTextHTML,
    headerText, 
    paragraphText,
    ...props
}) => {
    return (
        <Wrapper {...props}>
            {headerTextHTML &&  <H1 {...props}> {headerTextHTML} </H1> }
            {headerText && <H1 {...props}>{headerText}</H1>}
            {paragraphText && <P {...props}>{paragraphText}</P>}
        </Wrapper>
    )
}

export default HeaderAndParagraph;